/*
 * @Author: tianzhi
 * @Date: 2020-01-09 17:06:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-09 17:53:59
 */
export function getUrlParmas(attr) {
  let map = new Map();
  let href = window.location.href;
  let wenIndex = href.indexOf('?');
  let search = href.substring(wenIndex + 1);
  let arr = search.split('&');
  arr.forEach(v => {
    let i = v.indexOf('=');
    let key = v.substr(0, i);
    let value = v.substr(i + 1);
    map.set(key, value);
  });
  return map.get(attr);
}
export function getUrl() {
  let obj = {};
  let href = window.location.href;
  let wenIndex = href.indexOf('?');
  let search = href.substring(wenIndex + 1);
  let arr = search.split('&');
  arr.forEach(v => {
    let i = v.indexOf('=');
    let key = v.substr(0, i);
    let value = v.substr(i + 1);
    obj[key] = value;
  });
  return obj;
}
export function delUrlParmas(attr) {
  let href = window.location.href;
  let wenIndex = href.indexOf('?');
  let baseUrl = href.substring(0, wenIndex);
  let search = href.substring(wenIndex + 1);

  if (search.indexOf(attr) > -1) {
    let obj = {};
    let arr = search.split("&");
    arr.forEach(v => {
      let i = v.indexOf('=');
      let key = v.substr(0, i);
      let value = v.substr(i + 1);
      obj[key] = value;
    });
    delete obj[attr];
    baseUrl = Object.keys(obj).length === 0 ? baseUrl : baseUrl + '?';
    let url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    return url;
  }
}
export function delMoreUrlParams(aParam, url = window.location.href) {
  aParam.forEach(item => {
    const fromindex = url.indexOf(`${item}=`); //必须加=号，避免参数值中包含item字符串

    if (fromindex !== -1) {
      // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
      const startIndex = url.indexOf('=', fromindex);
      const endIndex = url.indexOf('&', fromindex);
      const hashIndex = url.indexOf('#', fromindex);
      let reg;

      if (endIndex !== -1) {
        // 后面还有search参数的情况
        const num = endIndex - startIndex;
        reg = new RegExp(`${item}=.{${num}}`);
        url = url.replace(reg, '');
      } else if (hashIndex !== -1) {
        // 有hash参数的情况
        const num = hashIndex - startIndex - 1;
        reg = new RegExp(`&?${item}=.{${num}}`);
        url = url.replace(reg, '');
      } else {
        // search参数在最后或只有一个参数的情况
        reg = new RegExp(`&?${item}=.+`);
        url = url.replace(reg, '');
      }
    }
  });
  const noSearchParam = url.indexOf('=');

  if (noSearchParam === -1) {
    url = url.replace(/\?/, ''); // 如果已经没有参数，删除？号
  }

  return url;
}